export const READING_STATUS = {
    ALREADY_READ: 1,
    NOT_READ: 0,
}
export const ROLE_NUMBER = {
    REGISTRAR : 2,
    HIGH_REGISTRAR : 3
}
export const DOCUMENT_CATEGORY = [
    {
        value:1,
        type:'OFFICIAL_LETTER',
        name:'Công văn'
    },
    {
        value:2,
        type:'ESTABLISHMENT_APPOINTMENT_DOCUMENT',
        name:'Giấy tờ thành lập / bổ nhiệm'
    },
    {
        value:3,
        type:'PERIODIC_INSPECTION_DOCUMENT',
        name:'Văn bản kiểm tra định kỳ'
    },
    {
        value:4,
        type:'TASK_ASSIGNMENT_FORM',
        name:'Phiếu phân công nhiệm vụ'
    },
]